<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><i>Lizzie Borden took an axe</i></p>
<p class="ded2"><i>and gave her mother forty whacks</i>,</p>
<p class="ded2"><i>and when she saw what she had done</i>,</p>
<p class="ded3"><i>she gave her father forty-one</i>.</p>
<p class="indent">Yoshitsune was a famous warrior who lived in medieval Japan. Because of the situation of the country at that time, he was sent to the northern provinces, where he was killed. Before he left he bade farewell to his wife, and soon after she wrote in a poem, “Just as you unreel the thread from a spool, I want the past to become present.” When she said this, actually she made past time present. In her mind the past became alive and <i>was</i> the present. So as Dogen said, “Time goes from present to past.” This is not true in our logical mind, but it is in the actual experience of making past time present. There we have poetry, and there we have human life.</p>
<p class="right"><span><span class="smallcaps">SHUNRYU SUZUKI</span>,</span></p>
<p class="right1"><span><i>Zen Mind, Beginner’s Mind</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frantmater.vue?6dd6a3ef